import React from "react";
import styles from "./statistics.module.scss";
import {
  getOnlineNodesCount,
  getOnlineUsersCount,
  getTodayDataConsumed,
  getTodayUsers,
  getTotalDataConsumed,
  getTotalUsers,
} from "../../api/stats.service";
import StatsCard from "../../components/Cards/StatsCard";
import Button, { BTN_VARIANTS } from "../../components/Button";

const cards = [
  { title: "Users Online", method: getOnlineUsersCount },
  { title: "dVPN Nodes Online", method: getOnlineNodesCount },
  { title: "Total Unique Users", method: getTotalUsers },
  { title: "Today's Unique Users", method: getTodayUsers },
  { title: "Total Data Consumed", method: getTotalDataConsumed },
  { title: "Today's Data Consumed", method: getTodayDataConsumed },
];

const Statistics = () => {
  return (
    <div className={styles.root}>
      <span className={styles.title}>
        Network <span className="blue-text">Statistics</span>
      </span>
      <section className={styles.cards}>
        {cards.map((c) => (
          <StatsCard key={c.title} {...c} />
        ))}
      </section>
      <Button
        variant={BTN_VARIANTS.primary}
        className={styles.btn}
        onClick={() => window.open("https://stats.sentinel.co/")}
      >
        <span>Stats Page</span>
      </Button>
    </div>
  );
};

export default Statistics;
